import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { TicketNotesComponent } from '../../ticket-notes.component';
import { NoteDataService } from 'src/app/core/services/note-data.service';
import { BaseUserWithRole } from '@sb-tools/typescript/models/base-user-with-role.model';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { HighlightMentionComponent } from '../../../../../shared/components/highlight-mention/highlight-mention.component';

@Component({
    selector: 'app-mention-notification',
    templateUrl: './mention-notification.component.html',
    styleUrls: ['./mention-notification.component.scss'],
    imports: [HighlightMentionComponent, TranslateModule],
})
export class MentionNotificationComponent implements OnInit, OnDestroy {
    @Input() noteId: number;
    @Input() usersWithoutAccess: BaseUserWithRole[];

    isShow = true;
    text = this.translateService.instant('You mentioned') + ' ';

    private unsubscriber = new Subject<void>();

    constructor(
        private noteDataService: NoteDataService,
        private translateService: TranslateService,
        @Inject(TicketNotesComponent) public parent: TicketNotesComponent,
    ) {}

    ngOnInit(): void {
        if (!this.usersWithoutAccess || this.usersWithoutAccess.length === 0) {
            return;
        }
        this.usersWithoutAccess.forEach((element, index, array) => {
            this.text += '@' + element.email;
            if (index === array.length - 2) {
                this.text += ' ' + this.translateService.instant('and') + ' ';
            } else {
                this.text += ', ';
            }
        });
        if (this.usersWithoutAccess.length > 1) {
            this.text += this.translateService.instant(
                'but these users do not have access to this ticket and will not be able to read the whole thread. Do you want to grant access now?',
            );
        } else {
            this.text += this.translateService.instant(
                'but this user does not have access to this ticket and will not be able to read the whole thread. Do you want to grant access now?',
            );
        }
    }

    grantAccess(): void {
        const userIds = [];
        this.usersWithoutAccess.forEach((element) => {
            userIds.push(element.id);
        });
        this.noteDataService
            .shareAccess(this.parent.ticket.id, this.noteId, userIds)
            .pipe(takeUntil(this.unsubscriber))
            .subscribe(() => {
                this.isShow = false;
            });
    }

    doNothing(): void {
        this.noteDataService
            .disableAccess(this.parent.ticket.id, this.noteId)
            .pipe(takeUntil(this.unsubscriber))
            .subscribe(() => {
                this.isShow = false;
            });
    }

    ngOnDestroy(): void {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
